import LoginPage from './LoginPage';

export * from './schema';

export default LoginPage;
